import { RouteObject } from "react-router-dom";
import CallCenterLanding from "./components/landing/landing";
import { CreatePayment } from "@features/cx/payments/components";
import { CreateServiceRequest } from "@features/cx/services/components";
import { CreateComplaintRequest } from "@features/cx/complaints/components";

export interface CallCenterDashboardRoute
  extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: CallCenterDashboardRoute[];
}

export const callCenterDashboardRoutes: CallCenterDashboardRoute[] = [
  {
    path: "call-center/dashboard",
    element: <CallCenterLanding />,
  },
  {
    path: "call-center/payment/create/:consumerId",
    element: <CreatePayment />,
  },
  {
    path: "call-center/services/create/:consumerId/:consumerNo",
    element: <CreateServiceRequest />,
  },
  {
    path: "call-center/complaints/create/:consumerId/:consumerNo",
    element: <CreateComplaintRequest />,
  },
];
